import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { UserRole } from 'api/graphql';
import {
  getUser,
  getToken,
  getRefreshing,
  getLoggedIn,
  getError,
  getLoading,
  getRole,
  AuthRootState,
} from 'redux/auth';

type UseAuth = {
  allowedRoles?: UserRole[];
};

export const useAuth = ({ allowedRoles }: UseAuth = {}): {
  user?: AuthRootState['auth']['user'];
  token?: AuthRootState['auth']['token'];
  loggedIn: boolean;
  role?: UserRole;
  error: AuthRootState['auth']['error'];
  loading: AuthRootState['auth']['loading'];
  refreshing: AuthRootState['auth']['refreshing'];
  isNotAllowed?: boolean;
} => {
  const user = useSelector(getUser);
  const token = useSelector(getToken);
  const loggedIn = useSelector(getLoggedIn);
  const role = useSelector(getRole);
  const error = useSelector(getError);
  const loading = useSelector(getLoading);
  const refreshing = useSelector(getRefreshing);

  const isNotAllowed = useMemo(
    () => !!allowedRoles?.length && role && !allowedRoles.includes(role),
    [allowedRoles, role]
  );

  return {
    user,
    token,
    loggedIn,
    role,
    error,
    loading,
    refreshing,
    isNotAllowed,
  };
};
